import { useParams, useNavigate } from "react-router-dom";
import { mockUsers } from "../data";
export const useUserData = () => {
    const { userId } = useParams();
    const navigate = useNavigate();
    // Determine if we're in edit mode
    const isEdit = Boolean(userId && userId !== "new");
    // Find user by ID if editing
    const user = isEdit
        ? mockUsers.find((u) => u.id === userId)
        : undefined;
    const navigateToUsers = () => {
        navigate("/users");
    };
    const navigateToEditUser = (userIdToEdit) => {
        navigate(`/users/${userIdToEdit}`);
    };
    // User data utilities
    const getUserById = (id) => {
        return mockUsers.find((u) => u.id === id);
    };
    const userExists = isEdit ? Boolean(user) : true;
    return {
        userId,
        isEdit,
        user,
        userExists,
        navigateToUsers,
        navigateToEditUser,
        getUserById,
    };
};
